import DineroFactory from "dinero.js";
import SectionPricing from "./SectionPricing";
import SectionPricingOption from "./SectionPricingOption";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../Common/_hooks/useAppSelector";
import Immutable from "immutable";
import { Alert, Stack, Typography } from "@mui/material";
import ProductOptionStore from "../../AppData/_stores/ProductOptionStore";

type Props = {
  productId: number;
}

export default function SectionShirtPricing(props: Props) {
  const [t] = useTranslation('page/products/_sections');
  const productData = useAppSelector(state => state.get('appData').get('products').get(String(props.productId)));
  const currency = useAppSelector(state => state.get('userData').get('prefs').get('currency'))

  const [priceDropship, priceRetail, priceWholesale] = useMemo(() => {
    if (!productData) {
      return [
        DineroFactory({ amount: 0, currency: currency }),
        DineroFactory({ amount: 0, currency: currency }),
        DineroFactory({ amount: 0, currency: currency }),
      ]
    }

    //Base product prices
    let tmpPriceDropship = productData.get('price_dropship').toDinero(),
      tmpPriceRetail = productData.get('price_retail').toDinero(),
      tmpPriceWholesale = productData.get('price_wholesale').toDinero();

    return [
      tmpPriceDropship,
      tmpPriceRetail,
      tmpPriceWholesale,
    ];
  }, [productData, currency]);

  const twoSidesOption = useMemo(() => {
    return productData?.get('availableOptionTypes').get('33')?.get('options').find((opt) => opt.get('slug') === 'two-sides');
  }, [productData])

  const biggerSizes = useMemo(() => {
    return productData?.get('availableOptionTypes').get('1')?.get('options').filter((opt) => !opt.get('price_dropship')?.toDinero().isZero());
  }, [productData])

  const renderBiggerSize = useCallback((option: ProductOptionStore) => {
    return <div key={option.get('id')}>{option.get('name') + ': +' + option.get('price_dropship').toDinero().toFormat()}</div>
  }, [])

  return <SectionPricing
    productId={props.productId}
    optionHeader={t('Printed side')}
    baseOptionName={t('One side printed')}
    Footer={biggerSizes && biggerSizes.count() > 0 ? <Alert severity="info">
      <Stack spacing={1}>
        {biggerSizes.valueSeq().map(renderBiggerSize)}
      </Stack>
    </Alert> : null}
  >
    {twoSidesOption ? <SectionPricingOption
      basePriceDropship={priceDropship}
      basePriceWholesale={priceWholesale}
      basePriceRetail={priceRetail}
      options={Immutable.Set([twoSidesOption])}
      name={t('Two sides printed')}
    /> : null}
  </SectionPricing>
}